import React, { useEffect, useState } from "react";
import { MailCheck } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import ParentAuthLayout from "./ParentAuthLayout";
import {
  persistParentPostAuthRedirect,
  readParentPostAuthRedirect,
} from "../../features/parentFlow/parentFlow";

const ParentVerificationPage = () => {
  const location = useLocation();
  const email = String(location.state?.email || "").trim();
  const [message, setMessage] = useState("");
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    persistParentPostAuthRedirect(readParentPostAuthRedirect());
  }, []);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setTimer((current) => (current > 0 ? current - 1 : 0));
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  const handleResend = async () => {
    const payload = new FormData();
    payload.append("email", email);

    try {
      await axiosInstance.post("api/sendlink", payload);
      setMessage("Verification email sent again.");
      setTimer(60);
    } catch (error) {
      setMessage(
        error?.response?.data?.message ||
          "Unable to resend the verification email right now."
      );
    }
  };

  return (
    <ParentAuthLayout
      title="Verify the Student Email"
      description="We’ve sent the same student verification link used by the existing sign-up flow."
      accent="Once the email is verified, use Parent Login with those student credentials to continue booking."
    >
      <div className="flex flex-col items-center text-center">
        <div className="flex h-24 w-24 items-center justify-center rounded-full bg-[#fff0ec] text-[#ff6b61]">
          <MailCheck size={42} />
        </div>

        <h2 className="mt-6 text-3xl font-bold text-[#111827]">
          Check the inbox
        </h2>
        <p className="mt-4 max-w-lg text-base leading-7 text-[#475569]">
          We sent a verification link to{" "}
          <span className="font-bold text-[#08059B]">
            {email || "the student email"}
          </span>
          . Open that email, verify the account, then come back and log in as
          a parent.
        </p>

        <button
          type="button"
          onClick={handleResend}
          disabled={!email || timer > 0}
          className="mt-8 rounded-full bg-[#08059B] px-6 py-3 text-base font-bold text-white transition hover:bg-[#01044F] disabled:cursor-not-allowed disabled:opacity-60"
        >
          {timer > 0 ? `Resend in ${timer}s` : "Resend verification email"}
        </button>

        {message ? (
          <p className="mt-4 text-sm font-medium text-[#475569]">{message}</p>
        ) : null}

        <div className="mt-10 rounded-[28px] border border-[#e6ded0] bg-[#fcfaf6] px-5 py-4 text-sm leading-7 text-[#475569]">
          Verified already?{" "}
          <Link className="font-bold text-[#08059B] underline" to="/parent/login">
            Go to Parent Login
          </Link>
        </div>
      </div>
    </ParentAuthLayout>
  );
};

export default ParentVerificationPage;
